import { chainCommands, exitCode } from 'prosemirror-commands';
import { TextSelection } from 'prosemirror-state';
import { logger } from '../../../logger';
import { isMac } from '../../../utils/platform';
import { isTextSelection } from '../../../utils/selection';
import { pType } from '../../base/BaseSchema/BaseSchemaSpecs';
import { BreaksSpecs, hbType, sbType } from './BreaksSpecs';
export { BreaksSpecs, BreakNodeName, hbType, sbType } from './BreaksSpecs';
export const Breaks = (builder, opts) => {
    var _a;
    let preferredBreak;
    if (builder.context.has('breaks')) {
        preferredBreak = builder.context.get('breaks') ? 'soft' : 'hard';
    }
    else {
        preferredBreak = (_a = opts.preferredBreak) !== null && _a !== void 0 ? _a : 'hard';
        logger.info("[Breaks extension]: Parameter 'breaks' is not defined in context; value from options is used");
    }
    builder.use(BreaksSpecs, { preferredBreak });
    builder.addKeymap(({ schema }) => {
        const cmd = addBr((preferredBreak === 'soft' ? sbType : hbType)(schema));
        const keys = {
            'Shift-Enter': cmd,
        };
        if (isMac()) {
            keys['Ctrl-Enter'] = cmd;
        }
        return keys;
    });
};
const addBr = (br) => chainCommands(exitCode, (state, dispatch) => {
    var _a;
    const { selection: sel, schema } = state;
    if (!isTextSelection(sel) ||
        !sel.empty ||
        // breaks can only be in the paragraph
        ((_a = sel.$cursor) === null || _a === void 0 ? void 0 : _a.parent.type) !== pType(schema))
        return false;
    if (isBreakNode(sel.$cursor.nodeBefore)) {
        if (dispatch) {
            const { $cursor, $cursor: { pos }, } = sel;
            const from = isBreakNode($cursor.nodeAfter) ? pos + 1 : pos;
            const posEnd = $cursor.end();
            const posAfter = $cursor.after();
            const contentAfter = state.doc.slice(from, posEnd, false).content;
            let tr = state.tr.insert(posAfter, pType(schema).create(null, contentAfter));
            tr = tr
                .setSelection(TextSelection.create(tr.doc, posAfter + 1))
                .scrollIntoView()
                .delete(pos, posEnd) // remove content after current pos (it's moved to next para)
                .delete(pos - 1, pos); // remove break before current pos ($cursor.nodeBefore)
            dispatch(tr);
        }
        return true;
    }
    dispatch === null || dispatch === void 0 ? void 0 : dispatch(state.tr.replaceSelectionWith(br.create()).scrollIntoView());
    return true;
});
function isBreakNode(node) {
    return Boolean(node === null || node === void 0 ? void 0 : node.type.spec.isBreak);
}
